import { Trans } from 'react-i18next';

import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../translations';

import { useDiagnosesFromLastVisitCopyLink } from './DiagnosesInteractiveTablePlaceholder.hooks';

type DiagnosesInteractiveTablePlaceholderProps = {
   readonly visitId: number;
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const DiagnosesInteractiveTablePlaceholder = (props: DiagnosesInteractiveTablePlaceholderProps): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={visitDetailsTranslationKeys.diagnoses.noResultsLabel}
         subheading={
            <Trans
               i18nKey={visitDetailsTranslationKeys.diagnoses.noResultsSubText}
               components={{
                  link: useDiagnosesFromLastVisitCopyLink({
                     visitId: props.visitId,
                     chronicDiseases: props.chronicDiseases,
                  }),
               }}
            />
         }
         fullLength
         testId={'noResults'}
      />
   );
};
